<template>
  <div>
    <div v-for="level in allLevels">
      <membership-card class="mb-1" :level="level" :next-level="nextLevel(level)"></membership-card>
    </div>
  </div>
</template>

<script>
import MembershipCard from "./MembershipCard";

export default {
  name: "LevelsList",
  props: ['allLevels'],
  components: {MembershipCard},
  methods : {
    nextLevel(level) {
      if (!level) return null;

      const currentIndex = this.allLevels.findIndex(item => item === level);
      const nextIndex = currentIndex + 1;

      return this.allLevels[nextIndex] || null;
    }
  },
  computed: {
    sortedLevels() {
      return this.allLevels.slice().sort((a, b) => b.amount - a.amount);
    },
  }
}
</script>

<style scoped>

</style>
